if (!customElements.get('index-hero-swiper')) {
  customElements.define(
    'index-hero-swiper',
    class IndexHeroSwiper extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;
        requestAnimationFrame(() => this.initSlider());
      }

      disconnectedCallback() {
        this._initialized = false;
        if (this._boundResize) {
          window.removeEventListener('resize', this._boundResize);
          this._boundResize = null;
        }
        if (this._slider?.destroy) {
          this._slider.destroy(true, true);
        }
        this._slider = null;
      }

      getSlideCount() {
        const n = parseInt(this.dataset.slideCount, 10);
        if (!Number.isNaN(n) && n > 0) return n;
        return this.querySelectorAll('.swiper-slide').length;
      }

      syncMobileHeroUi() {
        if (!window.matchMedia('(max-width: 767.98px)').matches) return;
        const slider = this._slider;
        const currentEl = this.querySelector('[data-index-hero-current]');
        const segments = this.querySelectorAll('.index-hero-swiper__mobile-line-segment');
        if (!slider || !currentEl || !segments.length) return;

        const total = this.getSlideCount();
        let idx = typeof slider.realIndex === 'number' ? slider.realIndex : slider.activeIndex;
        if (idx < 0 || idx >= total) idx = 0;

        const label = idx + 1 < 10 ? `0${idx + 1}` : String(idx + 1);
        currentEl.textContent = label;

        segments.forEach((seg, i) => {
          seg.classList.toggle('is-active', i === idx);
        });
      }

      initSlider() {
        // Navigation is already in FoxTheme.Carousel default modules — do NOT add it again
        const additionModules = [FoxTheme.Swiper.Autoplay];
        const slideCount = this.getSlideCount();

        const options = {
          slidesPerView: 1,
          spaceBetween: 0,
          grabCursor: true,
          allowTouchMove: true,
          threshold: 2,
          loop: false,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
        };

        if (slideCount > 1) {
          options.loop = true;
          options.breakpoints = {
            768: {
              loop: false,
            },
          };
        }

        const autoplayDelay = parseInt(this.dataset.autoplay, 10);
        if (autoplayDelay > 0) {
          options.autoplay = {
            delay: autoplayDelay,
            disableOnInteraction: false,
          };
        }

        const carousel = new window.FoxTheme.Carousel(this, options, additionModules);
        carousel.init();
        this._slider = carousel.slider;

        this._slider.on('slideChangeTransitionEnd', () => this.syncMobileHeroUi());

        this._boundResize = () => this.syncMobileHeroUi();
        window.addEventListener('resize', this._boundResize);
        this.syncMobileHeroUi();
      }
    }
  );
}
